import { Component, BaseTLDetailComponent, AxiosResponse, Watch, tlISODateTimeToLocalNoSecondsString, tlISODateToLocalString } from "../../../Infrastructure/CorBase/CoreBase";
import { TenantpaidService, TenantpaidFilter, TariffService, DiscountFilter, DiscountService } from "../../../Services/AccBase/AllAccServices";

interface FormData {
	idTariff: number;
	idTenant: number;
	idTariffName: string;
	maturityDay: string | null;
	urgentDay: string | null;
	isNew: boolean;
	diskSpace: string;
}

interface iFormDataTenantPayment {
	id: number;
	identifier: string;
	name: string;
	price: string;	
	priceMonth: string;	
	isSelected: boolean;
};

interface iFormDataContentHead {
	id: number;
	name: string;
	description: string;
	contents: iFormDataTenantPayment[];
};

interface iFormDataDiscount {
	id: number;
	discount: string;
	
};

	export default abstract class  TenantpaidDetailBase extends BaseTLDetailComponent {

		tenantpaidService: TenantpaidService = new TenantpaidService();
		tariffService: TariffService = new TariffService();
		discountService: DiscountService = new DiscountService();

        formData: FormData = {
            idTariff: 0,
            idTenant: 0,
            idTariffName: '',
            maturityDay: null,
            urgentDay: null,
            isNew: false,
			diskSpace: ""
        };

		tenantPaymentData: iFormDataTenantPayment[] = [{
			id: 1,
			identifier:'',
			name: 'jmeno',
			price: 'descdddt',	
			priceMonth: '',
			isSelected: false
		}];


		discountsData: iFormDataDiscount[] = [{
			id: 1,
			discount: '10 %'
		}];

		formHeadData: iFormDataContentHead[] = [
			{
				id: 1,
				description: '',
				name: this.$t('tenantpaid.fieldPaymentHead').toString(),
				contents: []
			}
		]


		items: any[] = [];
		typeTariffs: any[] = [];

		oldTariff = 0;
		oldMaturityDay = 'x';
		oldUrgentDay = 'x';

		@Watch('formData.idTariff')
		onPropertyTariff(value: string, oldValue: string) {
			if (value != oldValue) {
				if (value != null) {
					
					if (this.formData.idTariff != this.oldTariff) {
						var tariff = this.typeTariffs.filter((c: any) => c.value == value)[0];
						
						this.formData.maturityDay = tariff.maturityDay;
						this.formData.urgentDay = tariff.urgentDay;
						
					}
					else {
						this.formData.maturityDay = this.oldMaturityDay;
						this.formData.urgentDay = this.oldUrgentDay;
					}
				}
				
			}
		}

		isNew = true;
		loadBase() {
			this.isNew = true;
			this.fetchDataFromServer().then(res => {
				this.processResponse(res);
				this.isNew = false;
			}).catch(e => {
			});
		}

		loadEnums() {			
			this.typeTariffs = [];
			

			this.tariffService.getAll().then(res => {
				this.items = res.data;
				for (var i = 0; i < this.items.length; i++) {
					if (this.typeTariffs.filter((c: any) => c.value == this.items[i].id).length == 0) {
						this.typeTariffs.push({ value: this.items[i].id, text: this.items[i].name, description: this.items[i].name, maturityDay: this.items[i].maturityDay, urgentDay: this.items[i].urgentDay ,pricelistName: this.items[i].pricelistName});
					}
				}
				this.typeTariffs = this.typeTariffs.sort((a, b) => a.text.localeCompare(b.text));

				this.loadBase();
			});			
		}

		createdBase() {			
			this.loadEnums();
			this.loadDiscount();
		}

		protected doAction() {
			super.doCRUDActionWithInfoMessage(this.$t('tariff.messageNew').toString(), this.$t('tariff.messageEdit').toString(), this.$t('tariff.messageDelete').toString());
		}

		protected fetchDataFromServer(): Promise<AxiosResponse<any>> {
			return this.tenantpaidService.getById(this.$store.state.idTenant);
		}

		protected fetchRefreshDataFromServer(): Promise<AxiosResponse<any>> {
			return super.NoCall();
		}

		protected refreshItems(items: any, refreshData: any): any {
			return items;
		}

		protected processResponse(response: AxiosResponse<any>): void {
			this.formData.idTariff = response.data.idTariff;
			this.oldTariff = JSON.parse(JSON.stringify(this.formData.idTariff));

			this.tenantPaymentData = response.data.paymentItems;

			this.formData.idTenant = response.data.idTenant;
			this.formData.idTariffName = response.data.idTariffName;
			this.formData.maturityDay = response.data.maturityDay;
			this.formData.urgentDay = response.data.urgentDay;
			this.formData.isNew = response.data.isNew;
			var tariff = this.typeTariffs.filter((c: any) => c.value == this.formData.idTariff)[0];
			this.formData.diskSpace = response.data.diskSpace;
			if (this.formData.maturityDay == undefined || this.formData.urgentDay == undefined) {
				this.formData.maturityDay = tariff.maturityDay;
				this.formData.urgentDay = tariff.urgentDay;				
			}
			this.oldUrgentDay = JSON.parse(JSON.stringify(this.formData.urgentDay));
			this.oldMaturityDay = JSON.parse(JSON.stringify(this.formData.maturityDay));
		}

		protected afterCreate(response: AxiosResponse<any>): void {
			this.formData.idTenant = response.data.idTenant;
		}

		protected updateObject(): Promise<AxiosResponse<any>> {
			this.formData.idTenant = this.$store.state.idTenant;
			return this.tenantpaidService.update(this.$store.state.idTenant, this.formData);
		}

		updateBase() {
			this.formData.idTenant = this.$store.state.idTenant;
			this.tenantpaidService.update(this.$store.state.idTenant, this.formData).then(res => {
				this.processResponse(res);
				this.formIsInEditMode = false;
				if (this.formData.isNew) {
					this.showAlertModalWithInfoMessage(this.$t('pricelist.messageNew').toString());
				}
				else {
					this.showAlertModalWithInfoMessage(this.$t('pricelist.messageEdit').toString());
				}
			});
		}


		protected createObject(): Promise<AxiosResponse<any>> {		
			
			return this.tenantpaidService.create(this.formData);
		}

		protected deleteObject(): Promise<AxiosResponse<any>> {
			return this.tenantpaidService.delete(this.objectId);
		}
		
		vIsCorrectName: boolean = true;
		vIsCorrectMaturityDay: boolean = true;
		vIsCorrectUrgentDay: boolean = true;
	
		protected validateBase() {
			return !( this.vIsCorrectMaturityDay && this.vIsCorrectUrgentDay);
		}
		
		protected isCorrectNameBase(value: any) {
			this.vIsCorrectName = value;
		}

		protected isCorrectMaturityDayBase(value: any) {
			this.vIsCorrectMaturityDay = value;
		}

		protected isCorrectUrgentDayBase(value: any) {
			this.vIsCorrectUrgentDay = value;
		}

		itemSelected:any=null;
		changeCheckboxBase(item: any, item2: any, item3: any, item4: any) {
			this.itemSelected = this.tenantPaymentData.filter(c => c.id == item)[0];
			if (this.itemSelected.isSelected == false || this.itemSelected.identifier == "PrioryQue") {
				this.showAlertModalById(this.alertModalIdToDelete);
				
			}
		}

		selectFunctionBase() {
			this.tenantpaidService.selectPaymentTenant(this.$store.state.idTenant, this.itemSelected).then(res => {
				this.tenantPaymentData = res.data;
			});
		}

		fieldsPayment = [
			//{ key: 'id', label: 'id', trans: 'taskDetail.fieldName', sortable: false, class: 'text-left ', thClass: 'firstColumnMichael' },
			{ key: 'name', label: this.$t('tenantpaid.fieldName'), trans: 'tenantpaid.fieldName', sortable: false, class: 'text-left ', thClass: 'firstColumnMichael' },
			{ key: 'price', label: this.$t('tenantpaid.fieldPrice'), trans: 'tenantpaid.fieldPrice', sortable: false, class: 'text-center  ' },
			{ key: 'priceMonth', label: this.$t('tenantpaid.fieldPriceMonth'), trans: 'tenantpaid.fieldPriceMonth', sortable: false, class: 'text-center  ' },
			{ key: 'amoutFrom', label: this.$t('tenantpaid.fieldAmoutFrom'), trans: 'tenantpaid.fieldAmoutFrom', sortable: false, class: 'text-center  ' },
			{ key: 'amoutTo', label: this.$t('tenantpaid.fieldAmoutTo'), trans: 'tenantpaid.fieldAmoutTo', sortable: false, class: 'text-center  ' },
			{ key: 'isSelected', label: this.$t('tenantpaid.fieldIsSelected'), trans: 'tenantpaid.fieldIsSelected', sortable: false, class: 'text-center helpWidth30 ', design: 'checkBox' },
		
		];

		

		fieldsDiscount = [			
			{ key: 'discountText', label: this.$t('tenantpaid.fieldDiscountAmount'), trans: 'tenantpaid.fieldDiscountAmount', sortable: true, class: 'text-center' },
			{ key: 'validFrom', label: this.$t('tenantpaid.fieldValidFrom'), trans: 'tenantpaid.fieldValidFrom', sortable: true, class: 'text-left', formatter: (x: Date) => tlISODateToLocalString(x) },
			{ key: 'validTo', label: this.$t('tenantpaid.fieldValidTo'), trans: 'tenantpaid.fieldValidTo', sortable: true, class: 'text-left', formatter: (x: Date) => tlISODateToLocalString(x) },
			{ key: 'actions', label: '', class: 'text-right' }
		];


		loadDiscount() {
			let discountFilter: DiscountFilter = new DiscountFilter(this.$store.state.idTenant);
			this.discountService.getAllByFilter(discountFilter).then(res => {
				this.discountsData = res.data;
			});
		}

		deleteDiscountId: any = null;
		deleteDiscountBase(item: any) {
			this.deleteDiscountId = item;
			this.showAlertModalById("deleteDiscount");
		}

		deleteDiscountItem() {
			this.discountService.delete(this.deleteDiscountId).then(res => {
				this.loadDiscount();
			});
		}

		addNewDiscountBase() {
			this.$router.push({ name: "DiscountDetail" });
			// this.$router.push({ name: "DiscountDetail", params: { id: this.item.id.toString() }, query: { id: this.item.id.toString() } });
		}

		detailDiscountBase(item: any) {
			this.$router.push({ name: "DiscountDetail", params: { id: item.toString() }, query: { id: item.toString() } });
		}
	
	}
